<!DOCTYPE html>
<html lang="es">
    <head>
        <meta charset="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <title>Guía visual</title>
    </head>
    <body>
        <div class="adaptive-grow-1">
            <div class="fluent-container">
                <header>
                    <img src="/img/LOGO.png" alt="Logo" />
                    <p class="header-footer">SISTEMA DE REPORTES MADEJA</p>
                </header>

                <section>
                    <div class="title-color">
                        <h1>GUÍA VISUAL DE MARCA - ACIN CWK</h1>
                    </div>
                    <br />
                    <h2>COLORES</h2>
                    <h3>Colores del texto</h3>
                    <p class="paragraphs">
                        Los colores estan dados de la siguiente forma:<br />
                        Títulos: [#FFFFFF], <br />
                        Párrafos: [#000000]
                    </p>

                    <h3>Colores principales</h3>
                    <p class="paragraphs">
                        Los colores estan dados de la siguiente forma:<br />
                        Primario/Acento: [#1e7e34], <br />
                        Secundario: [#d4d4d4], <br />
                        Hover: [#343a40], <br />
                        Header: [#f8f9fa]
                    </p>
                    <div class="color-boxes">
                        <div class="color-box primary">
                            Primario<br />Acento
                        </div>
                        <div class="color-box secondary">Secundario</div>
                        <div class="color-box hover">Hover</div>
                        <div class="color-box color-secondary">Header</div>
                    </div>
                    <br />
                    <h3>Colores de estado</h3>
                    <p class="paragraphs">
                        Los colores estan dados de la siguiente forma:<br />
                        Éxito: [#28a745], <br />
                        Advertencia: [#ffc107], <br />
                        Error: [#dc3545], <br />
                        Información: [#17a2b8]
                    </p>
                    <div class="color-boxes">
                        <div class="color-box color-success">Éxito</div>
                        <div class="color-box color-warning">Advertencia</div>
                        <div class="color-box color-error">Error</div>
                        <div class="color-box color-info">Información</div>
                    </div>
                </section>

                <section>
                    <h2>BOTONES</h2>
                    <button class="primary-button" type="button">
                        <span class="button-content"
                            ><mat-icon fontIcon="home">home</mat-icon
                            >Primario</span
                        >
                    </button>
                    <button class="secondary-button" type="button">
                        <span class="button-content"
                            ><mat-icon fontIcon="home">home</mat-icon
                            >Secundario</span
                        ></button
                    ><br /><br />
                    <h3>Estados de los botones</h3>
                    <button class="primary-button" type="button">
                        <span class="button-content"
                            ><mat-icon fontIcon="home">home</mat-icon
                            >Normal</span
                        >
                    </button>
                    <button class="secondary-button" type="button">
                        <span class="button-content"
                            ><mat-icon fontIcon="home">home</mat-icon
                            >Normal</span
                        >
                    </button>
                    <button
                        class="primary-button"
                        type="button"
                        style="background-color: var(--color-hover-button)"
                    >
                        <span class="button-content"
                            ><mat-icon fontIcon="home">home</mat-icon
                            >Hover</span
                        >
                    </button>
                    <button
                        type="button"
                        class="primary-button disabled-button disabled-button-primary"
                        disabled
                    >
                        <span class="button-content"
                            ><mat-icon fontIcon="home">home</mat-icon
                            >Deshabilitado</span
                        >
                    </button>
                    <button
                        type="button"
                        class="secondary-button disabled-button disabled-button-secondary"
                        disabled
                    >
                        <span class="button-content"
                            ><mat-icon fontIcon="home">home</mat-icon
                            >Deshabilitado</span
                        >
                    </button>
                </section>

                <section>
                    <h2>TIPOGRAFÍA</h2>
                    <p class="paragraphs">
                        Century Gothic Regular - Párrafos comunes
                    </p>
                    <p class="headings-emphasis">
                        Century Gothic Bold - Títulos y énfasis
                    </p>
                    <p class="header-footer">
                        Roboto Regular - Header y footer
                    </p>
                    <h2>JERARQUÍA DE TÍTULOS</h2>
                    <br />
                    <h1 style="text-align: left; color: #000000">
                        h1 - TÍTULO PRINCIPAL
                    </h1>
                    <h2>h2 - SUBTÍTULO</h2>
                    <h3>h3 - Sección</h3>
                    <h4>h4 - Subsección</h4>
                    <h5>h5 - Nota</h5>
                    <h6>h6 - Pie o aclaración</h6>
                </section>

                <section>
                    <h2>ICONOS</h2>
                    <br />
                    <p class="paragraphs">
                        Estilo de íconos: Material Icons - tamaño base de 20px.
                    </p>
                    <p class="paragraphs">
                        Consulta
                        <a
                            href="https://fonts.google.com/icons?hl=es-419"
                            target="_blank"
                            rel="noopener noreferrer"
                            >aquí los iconos</a
                        >
                        disponibles de Google Fonts.
                    </p>
                    <span class="material-icons icon icon--primary">home</span>
                    <span class="material-icons icon icon--info">info</span>
                </section>

                <section>
                    <h2>USO DEL LOGO</h2>
                    <br />
                    <p class="paragraphs">
                        El logo debe usarse sin fondo, en alta resolución y con
                        espacio mínimo de protección.
                    </p>
                    <div class="img-content">
                        <div style="text-align: center">
                            <img
                                src="/img/LOGO.png"
                                alt="Uso correcto del logo"
                                width="100"
                            />
                            <p class="color-text-success paragraphs">
                                Uso correcto
                            </p>
                        </div>
                        <div style="text-align: center">
                            <img
                                src="/img/LOGO.png"
                                alt="Uso incorrecto del logo"
                                width="100"
                                style="filter: grayscale(1); opacity: 0.7"
                            />
                            <p class="color-text-error paragraphs">
                                No deformar ni poner en fondo oscuro
                            </p>
                        </div>
                    </div>
                </section>

                <div class="adaptive-grow-1">
                    <div class="fluent-container">
                        <h2>CAMPOS DE ENTRADA</h2>
                        <div class="form-body">
                            <div class="line">
                                <div
                                    class="column-md-3 column-lg-3 column-sm-6"
                                >
                                    <mat-form-field appearance="outline">
                                        <mat-label>Caja de texto</mat-label>
                                        <input
                                            type="text"
                                            matInput
                                            required
                                            name="input"
                                            id="input"
                                        />
                                        <mat-error class="for-text text-danger">
                                            Campo obligatorio.
                                        </mat-error>
                                    </mat-form-field>
                                </div>

                                <div
                                    class="column-md-3 column-lg-3 column-sm-6"
                                >
                                    <mat-form-field appearance="outline">
                                        <mat-label>Select nativo</mat-label>
                                        <select matNativeControl required>
                                            <optgroup
                                                label="Seleccione una opción"
                                            >
                                                <option value=""></option>
                                                <option value="opcion1">
                                                    opcion1
                                                </option>
                                                <option value="opcion2">
                                                    opcion2
                                                </option>
                                                <option value="opcion3">
                                                    opcion3
                                                </option>
                                            </optgroup>
                                        </select>
                                    </mat-form-field>
                                </div>

                                <div
                                    class="column-md-3 column-lg-3 column-sm-6"
                                >
                                    <mat-form-field appearance="outline">
                                        <mat-label>Múltiple</mat-label>
                                        <mat-select multiple>
                                            <mat-option value="option"
                                                >option</mat-option
                                            >
                                            <mat-option value="option1"
                                                >option1</mat-option
                                            >
                                            <mat-option value="option2"
                                                >option2</mat-option
                                            >
                                            <mat-option value="option3"
                                                >option3</mat-option
                                            >
                                        </mat-select>
                                    </mat-form-field>
                                </div>

                                <div
                                    class="column-md-3 column-lg-3 column-sm-6"
                                >
                                    <mat-form-field appearance="outline">
                                        <mat-label>select</mat-label>
                                        <mat-select required>
                                            <mat-option></mat-option>
                                            <mat-option value="opcion1"
                                                >opcion1</mat-option
                                            >
                                            <mat-option value="opcion2"
                                                >opcion2</mat-option
                                            >
                                            <mat-option value="opcion3"
                                                >opcion3</mat-option
                                            >
                                        </mat-select>
                                    </mat-form-field>
                                </div>

                                <div
                                    class="column-md-3 column-lg-3 column-sm-6"
                                >
                                    <mat-form-field appearance="outline">
                                        <mat-label>Fecha</mat-label>
                                        <input
                                            matInput
                                            [matDatepicker]="picker"
                                        />
                                        <mat-datepicker-toggle
                                            matSuffix
                                            [for]="picker"
                                        ></mat-datepicker-toggle>
                                        <mat-datepicker
                                            #picker
                                        ></mat-datepicker>
                                    </mat-form-field>
                                </div>

                                <div
                                    class="column-md-3 column-lg-3 column-sm-6"
                                >
                                    <mat-checkbox class="example-margin"
                                        >Checkbox</mat-checkbox
                                    >
                                </div>

                                <div
                                    class="column-md-3 column-lg-3 column-sm-6"
                                >
                                    <mat-radio-button value="1"
                                        >Radio</mat-radio-button
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <section>
                    <h2>ALERTAS - TOASTR</h2>
                    <h3>Ejemplo visual</h3>
                    <div style="margin-top: 1rem">
                        <button
                            class="primary-button color-success"
                            (click)="mostrarToastr('success')"
                        >
                            Éxito
                        </button>
                        <button
                            class="secondary-button color-error"
                            (click)="mostrarToastr('error')"
                        >
                            Error
                        </button>
                        <button
                            class="secondary-button color-warning"
                            (click)="mostrarToastr('warning')"
                        >
                            Advertencia
                        </button>
                        <button
                            class="secondary-button color-info"
                            (click)="mostrarToastr('info')"
                        >
                            Info
                        </button>
                    </div>
                </section>
                <br />

                <section>
                    <h2>VISTA DE EJEMPLO</h2>
                    <div class="adaptive-grow-1">
                        <div class="fluent-container">
                            <div class="title-color">
                                <h1>BIENVENIDO A ACIN - CWK</h1>
                            </div>
                            <p class="paragraphs">
                                Esta es una muestra de cómo lucen los
                                <span class="headings-emphasis"
                                    >colores, tipografías y botones</span
                                >
                                integrados en un componente real.
                            </p>
                            <div class="form-body">
                                <form>
                                    <div class="line">
                                        <div
                                            class="column-md-3 column-lg-6 column-sm-6"
                                        >
                                            <mat-form-field
                                                appearance="outline"
                                            >
                                                <mat-label>Nombre</mat-label>
                                                <input
                                                    type="text"
                                                    matInput
                                                    required
                                                    placeholder="Ingresa tu nombre"
                                                />
                                            </mat-form-field>
                                        </div>

                                        <div
                                            class="column-md-3 column-lg-6 column-sm-6"
                                        >
                                            <mat-form-field
                                                appearance="outline"
                                            >
                                                <mat-label
                                                    >Correo
                                                    electrónico</mat-label
                                                >
                                                <input
                                                    type="email"
                                                    matInput
                                                    placeholder="ejemplo@correo.com"
                                                />
                                            </mat-form-field>
                                        </div>
                                    </div>

                                    <button
                                        class="primary-button"
                                        type="button"
                                    >
                                        <span class="button-content"
                                            ><mat-icon fontIcon="save"
                                                >save</mat-icon
                                            >Guardar</span
                                        >
                                    </button>
                                    <button
                                        class="secondary-button"
                                        type="button"
                                    >
                                        <span class="button-content"
                                            ><mat-icon fontIcon="close"
                                                >close</mat-icon
                                            >Cancelar</span
                                        >
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </section>

                <!-- <footer>
                    <h5>© 2025 Acin CWK. Todos los derechos reservados.</h5>
                    <h6>
                        Contáctanos:
                        <a></a>
                    </h6>
                </footer> -->
            </div>
        </div>
    </body>
</html>
